<template>
  <div>
    <img
      src="../../static/product/product.png"
      ref="bannerHeight"
      alt="img"
      class="img"
    />
    <div class="pd-header">
      <div class="product-desc">
        <div class="product-desc-title">{{ showPDHeader().title }}</div>
        <div class="product-desc-sub-title">{{ showPDHeader().subTitle }}</div>
        <div class="product-desc-content">{{ showPDHeader().info }}</div>
      </div>
    </div>
    <!--Tab1-->
    <product-item1
      v-if="$route.query.type === '1'"
      id="section1"
    ></product-item1>
    <!--Tab2-->
    <product-item2 v-if="$route.query.type === '2'"></product-item2>
    <!--Tab3-->
    <product-item3 v-if="$route.query.type === '3'"></product-item3>
  </div>
</template>
<script>
import ProductItem1 from "@/views/component/productItem1.vue";
import ProductItem2 from "@/views/component/productItem2.vue";
import ProductItem3 from "@/views/component/productItem3.vue";

export default {
  components: { ProductItem3, ProductItem2, ProductItem1 },
  data() {
    return {};
  },
  mounted() {
    scrollTo({ top: 0 });
  },
  methods: {
    showPDHeader() {
      let type = this.$route.query.type;
      let title = "";
      let subTitle = "";
      let info = "";
      if (type === "1") {
        title = "信息软件服务";
        subTitle = "一站式解决体检管理难题";
        info =
          "为不同规模的健康体检中心提供全流程的信息化解决方案，包括检前预约、检中一体化体检信息管理系统、全流程智能导检系统、检后随访及报告解读、视频问诊系统、职业病体检系统、移动外检体检系统 、体 检 行 业 专 用 的 客 户 开 发 管 理 系 统（CDM）、LIS系统、PACS系统以及移动端微信公众号、小程序、自助机等系统。";
      }
      if (type === "2") {
        title = "运营管理服务";
        subTitle = "十九年运营管理经验";
        info =
          "凭借十九年健康体检中心运营经验，通过将服务组件模块化，增强机构对人、财、物等综合资源的协调统一，保证医疗质量的同时，实现健康体检中心口碑的有效提升。";
      }
      if (type === "3") {
        title = "售后服务";
        subTitle = "十六年体检信息化研发迭代经验积累";
        info =
          "用户需求调研，系统开发、系统上线、后续支持，全过程实现可视化、规范化管理，根据客户反馈，支持持续迭代更新系统，提供更智能、高效和个性化的售后支持和服务，提升运维服务效率、内部管理效率和客户满意度。";
      }
      return {
        title: title,
        subTitle: subTitle,
        info: info,
      };
    },
  },
};
</script>
<style scoped lang="less">
.img {
  width: 100%;
}
.pd-header {
  width: 100%;
  height: 456px;
  background: #fafafa;
}
.product-desc {
  width: 1200px;
  margin: 0 auto;
  padding-top: 78px;
  .product-desc-title {
    text-align: center;
    font-size: 38px;
    color: #125497;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-bottom: 22px;
  }
  .product-desc-sub-title {
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 70px;
  }
  .product-desc-content {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 33px;
    text-indent: 28px;
  }
}

//
</style>
